import { RelayRefetchProp } from 'react-relay';

type VariablesType = { [key: string]: boolean | string };
type CallbackFnType = () => void;

export const handleUserRefetch = (
    relay: RelayRefetchProp,
    setIsClient: (isClient: boolean) => void
): ((
    variables: VariablesType,
    renderVariables: VariablesType,
    callback: CallbackFnType
) => void) => {
    return (variables: VariablesType, renderVariables: VariablesType, callback: CallbackFnType) => {
        const isClient: boolean = variables?.isClient === true;
        setIsClient(isClient);
        /**
         * Only set variables that are directly used by the `SbRespCreatorsLayoutRefetchQuery` and `
         * SbMobileCreatorsLayoutRefetchQuery`queries.
         */
        const { userId, fetchUser, followSearchPages, followSearchTypes } = variables;
        relay.refetch(
            {
                userId,
                fetchUser,
                followSearchPages,
                followSearchTypes,
            },
            null,
            callback
        );
    };
};
